import Instafeed from './Instafeed';

export default Instafeed;
